import React, { lazy } from 'react'

import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const IDIndex = lazy(() => import('./:id/Index'))

export const CrewWageCarAssignmentRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--human-resources--crew-wage-car']}>
    <Route path=':id/*' element={<IDIndex />} />
  </SubRouter>
))
